<template>
  <!-- 表情包库 -->
  <a-popover v-model:visible="showEmojiPicker" trigger="click">
    <label class="icon-box" for="uploadImage" @click="toggleEmojiPicker">
      <auth-img class="icon-img" src="@/assets/img/chat/emoji.png" alt="" />
      <div class="icon-label">表情包</div>
    </label>
    <template #content>
      <div class="emoji-header" v-show="recentEmojis.length !== 0">
        <span>最近使用</span>
      </div>
      <div class="emoji-row">
        <div
          v-for="emoji in recentEmojis"
          :key="emoji.code"
          class="emoji-item"
          :class="{ selected: isEmojiSelected(emoji.code) }"
          @click="selectEmoji(emoji)"
        >
          <auth-img :src="emoji.iconPath" :alt="emoji.label" />
        </div>
      </div>
      <div class="emoji-header">
        <span>所有表情</span>
      </div>
      <div class="emoji-row">
        <div
          v-for="emoji in emojiList"
          :key="emoji.code"
          class="emoji-item"
          :class="{ selected: isEmojiSelected(emoji.code) }"
          @click="selectEmoji(emoji)"
        >
          <auth-img :src="emoji.iconPath" :alt="emoji.label" />
        </div>
      </div>
    </template>
  </a-popover>
</template>

<script setup>
import { ref, defineEmits, defineProps } from 'vue'
import emojiList from './config'
const props = defineProps({
  emojis: {
    type: Array,
    default: () => []
  }
})
const recentEmojis = ref(props.emojis)
const selectedEmojis = ref([])
const showEmojiPicker = ref(false)
const emits = defineEmits(['selectEmoji'])
const toggleEmojiPicker = () => {
  showEmojiPicker.value = !showEmojiPicker.value
}

const selectEmoji = emoji => {
  emits('selectEmoji', emoji)
  toggleEmojiPicker()
}

const isEmojiSelected = code => selectedEmojis.value.includes(code)
</script>

<style lang="scss" scoped>
@import '../../index.scss';

.emoji-picker {
  position: absolute;
  top: -340px; /* 初始位置在按钮上方，具体数值根据表情包高度调整 */
  // left: 50%;
  transform: translateX(-50%);
  width: 400px; /* 根据emoji数量和每行宽度调整 */
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  background-color: white;
  border: 1px solid #ccc;
  padding: 10px;
}
.emoji-header {
  padding: 10px;
  height: 17px;
  font-weight: 400;
  font-size: 12px;
  margin-bottom: 10px;
  color: #333333;
}
.emoji-row {
  display: flex;
  flex-wrap: wrap;
  width: 400px;
}

.emoji-item {
  flex-basis: calc(10% - 10px); /* 减去margin和padding的总宽度以确保正好10个 */
  max-width: calc(10% - 10px);
  cursor: pointer;
  padding: 5px;
  margin: 5px;
  text-align: center;
}

.emoji-item img {
  width: 28px; /* emoji大小，根据需要调整 */
  height: 28px;
  border-radius: 5px;
}

.selected img {
  border: 2px solid blue;
}
</style>
